import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { FieldErrorText } from '@/components/functional/Form/FieldErrorText/FieldErrorText';
import { TextField } from '@/components/functional/Form/TextField';
import { FieldLabel } from '@/components/ui/Form/FieldLabel';
import { FIELD_DOM_CLASS_NAME } from '@/utils/form/scroll';
import { validateLastName, validateFirstName } from '@/utils/validate/common';
/**
 * お問い合わせ 名前入力フィールド
 * @param props
 * @returns
 */
export const ContactMainNameField = (props) => {
    const { className = '', firstNameFieldName, firstNameInputRef, lastNameFieldName, lastNameInputRef, } = props;
    return (_jsxs("div", Object.assign({ className: clsx(FIELD_DOM_CLASS_NAME) }, { children: [_jsxs(FieldLabel, Object.assign({ childWrapClassName: clsx('flex flex-nowrap', 'flex-col sm:flex-row', 'gap-x-[4%] gap-y-8'), className: clsx(className), labelText: '氏名' }, { children: [_jsx(TextField, { isHideValidateError: true, name: lastNameFieldName, placeholder: '姓', setRef: lastNameInputRef, type: 'text', validate: validateLastName }), _jsx(TextField, { isHideValidateError: true, name: firstNameFieldName, placeholder: '名', setRef: firstNameInputRef, type: 'text', validate: validateFirstName })] })), _jsx(FieldErrorText, { name: lastNameFieldName }), _jsx(FieldErrorText, { name: firstNameFieldName })] })));
};
